import { logFailure } from 'utils/log';

import messages from './messages';

export const getMessageByIntlKey = ({ availableMessages, intlKey }) => {
  if (availableMessages[intlKey]) return availableMessages[intlKey];

  logFailure({ message: `[Not found message by intl key] Intl key: ${intlKey}` });

  return messages.notFoundMessage;
};

export default getMessageByIntlKey;
